module.exports = __webpack_public_path__ + "static/media/WORDLE.9f5e9327.png";